export const ACTION_TYPES = {
  SET_PRIMARY_MENU: "set_primary_menu",
  SET_SECONDARY_MENU: "set_secondary_menu",
  RESET_SEARCH_RESULTS: "reset_search_results",
  SET_SEARCH_RESULTS: "set_search_results",
  SET_SEARCH_TEXT: "set_search_text",
  TOGGLE_CHECKBOX_BY_ID_TYPE: "toggle_checkbox_by_id_type",
  TOGGLE_ALL_CHECKBOX_TYPE: "toggle_all_checkbox_type",
  SET_TG_VALUE: "set_tg_value",
  SET_TD_VALUE: "set_td_value",
  SET_DK_VALUE: "set_dk_value",
  SET_DF_VALUE: "set_df_value",
};
